import useGetColors from "../../utils/colors";

export const useGetBackButtonStyles = () => {
  const { themeColors } = useGetColors();

  return {
    backArrow: {
      color: "#fff",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "10px 20px",
      borderRadius: "50px",
      backgroundColor: "rgba(255, 255, 255, 0.15)",
      border: "1px solid rgba(255, 255, 255, 0.25)",
      fontSize: "16px",
      fontWeight: 500,
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.25)",
        transform: "translateX(-2px)",
      },
      "& svg": {
        fontSize: "20px",
      },
    },
  };
};
